import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Drawer, Space, Popconfirm } from 'antd';
import { AccessControl } from 'components/AccessControl';
import { RecordFields } from 'components/RecordFields';
import React from 'react';
import { truncateString } from 'utils';

function RecordInfoDrawer({
  drawerTitle,
  record,
  recordFields,
  isVisible,
  onClose,
  onEdit,
  onDelete,
  deleteConfirmText,
  extraActions,
  pageId,
  children,
  withActions = true,
  editable = true,
  width = '50%',
}) {
  const renderDrawerActions = () => {
    if (!withActions) {
      return null;
    }

    return (
      <Space>
        {extraActions}
        {editable ? (
          <AccessControl pageId={pageId} action="update">
            <Button type="default" onClick={onEdit} icon={<EditOutlined />} />
          </AccessControl>
        ) : null}

        {deleteConfirmText && (
          <AccessControl pageId={pageId} action="delete">
            <Popconfirm
              title={deleteConfirmText}
              placement="bottomLeft"
              onConfirm={onDelete}
              okText="Да"
              cancelText="Нет"
            >
              <Button type="default" danger icon={<DeleteOutlined />} />
            </Popconfirm>
          </AccessControl>
        )}
      </Space>
    );
  };

  return (
    <Drawer
      title={drawerTitle ? truncateString(drawerTitle, 60) : ''}
      width={width}
      onClose={onClose}
      visible={isVisible}
      extra={renderDrawerActions()}
    >
      {record && <RecordFields record={record} fields={recordFields} />}
      {children}
    </Drawer>
  );
}

export { RecordInfoDrawer };
